var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-card',{attrs:{"min-width":"100%"}},[_c('v-card-title',[_c('span',{staticClass:"text-h4"},[_vm._v("Sorry, Not yet working :c")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }